/*
 *   Copyright (c) 2021 Propally.Inc
 *   All rights reserved.
 */
import dayjs = require("dayjs");
import { isObject } from "lodash";
import _ = require("lodash");

export const castFieldInputs = (d, { doubleFieldNames = [], dateFieldNames = [] }) => {
  const data = _.cloneDeep(d);
  Object.keys(data).forEach((key) => {
    if (isObject(data[key]))
      data[key] = castFieldInputs(data[key], { doubleFieldNames: doubleFieldNames, dateFieldNames: dateFieldNames });

    if (dateFieldNames.includes(key)) {
      data[key] = dayjs(data[key]).format("YYYY-MM-DD");
    }
    if (doubleFieldNames.includes(key)) {
      data[key] = parseFloat(data[key]);
    }
  });
  return data;
};
